import { guards } from '@shared/helpers/typeguards.helpers';

type ApplyOptionsWithAmplitude = {
  amplitude?:
    | string
    | {
        eventType: string;
        eventProperties?: Record<string, unknown>;
      };
};

/**
 * Points Amplitude `VersionId` at the version that was actually created.
 * No-op when `amplitude` is omitted or a bare event-type string.
 */
export const stampApplyAmplitudeVersionId = <T extends object>(
  applyOptions: (T & ApplyOptionsWithAmplitude) | undefined,
  versionId: string,
): (T & ApplyOptionsWithAmplitude) | undefined => {
  if (!applyOptions) return applyOptions;
  const { amplitude } = applyOptions;
  if (!amplitude || guards.is.string(amplitude)) return applyOptions;
  return {
    ...applyOptions,
    amplitude: {
      ...amplitude,
      eventProperties: {
        ...amplitude.eventProperties,
        VersionId: versionId,
      },
    },
  };
};
